module.exports = __webpack_public_path__ + "img/2_icn_online_exp.bc4f6430.svg";